import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { MenuService } from 'src/app/shared/services/menu.service';
import { TYPE_TABLE, TIMELINE_DURATION } from 'src/app/timeline/timeline.interface';
import { TimelineService } from 'src/app/timeline/timeline.service';
@Component({
    selector: 'app-timeline-home',
    templateUrl: './timeline-home.component.html',
    styleUrls: ['./timeline-home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimelineHomeComponent implements OnInit {

	@ViewChild('timelineWrapper', { static: false }) timelineWrapper: ElementRef;
	@Input() isMainPage: boolean = true;
	@Input() maxHeight: Number = null;
	readonly TYPE_TABLE = TYPE_TABLE;
	readonly TIMELINE_DURATION = TIMELINE_DURATION;
	currentProject: any = null;
	projectId: any = null;

	typeTable: TYPE_TABLE = TYPE_TABLE.Daily;
	timelineDuration: TIMELINE_DURATION = TIMELINE_DURATION.TwoYears;
	loading: boolean = false;
	search_text: string = "";
	dateTimeline: string;
	userDate: string;
	view: string = 'home';
	projects: any = [];
	weeks: any;
	selected = {
		'project': null,
		'phase': null,
		'task': null,
		'chapter': null,
	};
	currentOpen = {
		'projects': [],
		'phases': []
	}
	contextMenu: string;
	infoProjectPhases: any;
	totalProjectsHeight: number = 0;
	positionTask: number = 1;
	header: any;
	currentScroll: number = 0;
	module: any = {
		'name': null,
		'access': null
	};
	phasesProject: any[] = [];

	filter() {

	}

	loadData(saveScroll = true) {
		this.changeView('home');
		this.currentScroll = this.timelineWrapper && saveScroll ? this.timelineWrapper.nativeElement.scrollLeft : null;
		this.loading = true;
		this._tS.getInfoPhasesProject(this.dateTimeline, this.typeTable, this.projectId, this.module, this.timelineDuration).subscribe(
			(data: any) => {
				this.projects = data.project;
				this.header = data.header;
				this.infoProjectPhases = {
					'phases': data.phases,
					'task_duration_type': data.task_duration_type,
					'task_start_at': data.task_start_at,
					'task_unit': data.task_unit,
					'countries': data.countries
				};
				this.phasesProject = data.project[0].phases_project;
				if (this.currentProject) {
					this.setDataForProject();
				}

				const HAS_PENDING_REQUESTS = this.configProjectsData();
				if (!HAS_PENDING_REQUESTS) {
					this.loading = false;
					this.setScrollTimeLine(this.currentScroll);
				}
			}
		)
	}

	getNameDateStorageProject() {
		let dateItem = `timeline_start_date_${this.projectId}`;
		if (this.module.name == 'post') {
			dateItem += '_post'
		}
		return dateItem;
	}

	setDataForProject() {
		let dateItem = this.getNameDateStorageProject();
		this.dateTimeline = this.header.days[0].date;
		localStorage.setItem(dateItem, this.dateTimeline ? this.dateTimeline : '');

		if (this.module.name == 'post') {
			this.projects = this.projects
				.map(p => {
					p.phases_project = p.phases_project.filter(ph => ph.phase_id == 4 || ph.phase_id == 3);
					return p;
				});

			this.infoProjectPhases.phases = this.infoProjectPhases.phases.filter(ph => ph.id == 4);
		}
	}

	setProjectHeight(project) {
		if (project.isOpen || project.phases_project.length < 2) {
			project.height = this._tS.BOX_SIZE * 2
		} else if (!project.isOpen) {
			project.height = (this._tS.BOX_SIZE / 2) * (project.phases_project.length + 2);
		}
	}

	configProjectsData(): boolean {
		let phasesPendingTasks = [];
		let requests = [];
		for (const project of this.projects) {

			project.isOpen = this.currentOpen.projects.indexOf(project.id) > -1 || this.currentProject ? true : false;
			this.setProjectHeight(project);

			project.phases_project.map(phase => {
				phase.tasks = [];
        phase.isOpen = this.currentOpen.phases.indexOf(phase.id) > -1 || this.module.name == 'post' ? true : false;

        if (this.module.name == 'post' && phase.phase_id == 3) {

          phase.isOpen = false
          phase.isDetail = true
          const weeksDetail = phase.duration / 7
          phase.weeksDetail = []
          for (let i = 0; i < weeksDetail; i++){
            phase.weeksDetail.push({
              'week': (i+1)
            })
          }
        }

				phase.color_code = this.getColorPhase(phase.phase_id);

				if (phase.isOpen) { // saves phases that needs to retrieve tasks
					phasesPendingTasks.push(phase);
					requests.push(this._tS.getProjectTasks(phase.id, this.dateTimeline, this.timelineDuration));
				}
			})
		}

		// Gets tasks for phases that were already open
		forkJoin(requests).subscribe(
			(data: any) => {
				for (let i = 0; i < data.length; i++) {
					this.mapTasks(data[i].tasks);
					phasesPendingTasks[i].tasks = data[i].tasks;
					this.setTasksColor(phasesPendingTasks[i].tasks);
					phasesPendingTasks[i].duration = data[i].phase_real_duration ? data[i].phase_real_duration : phasesPendingTasks[i].duration;
					phasesPendingTasks[i].week = data[i].phase_weeks ? data[i].phase_weeks : phasesPendingTasks[i].week;
				}
				this.loading = false;
				this.setScrollTimeLine(this.currentScroll);
			},
			err => {
				this.loading = false;
			}
		);

		return phasesPendingTasks.length ? true : false;
	}

	getColorPhase(phaseId) {
		switch (phaseId) {
			case 1:
				return '#d2fafc';
			case 2:
				return '#fdfaa7';
			case 3:
				return '#9ef7a5';
			case 4:
				return '#edc1fd';
		}
	}

	toggleProject(project) {
		if (this.currentProject) return;
		project.isOpen = !project.isOpen;
		this.setProjectHeight(project);
		this.updateOpenElements(project.isOpen, project.id, 'projects');
		this.projects = this.projects.slice(); //trigger changes
	}

	togglePhase(phase) {
		if (!this.isMainPage) {
			this.router.navigate(['projects', this.projectId, 'timeline']);
		}
		else {
			if (this.module.name == 'post') return;
			phase.isOpen = !phase.isOpen;
			this.updateOpenElements(phase.isOpen, phase.id, 'phases');
	
			if (phase.isOpen) {
				this.getPhaseTasks(phase);
			} else {
				this.projects = this.projects.slice(); //trigger changes
			}
		}
	}

	updateOpenElements(isOpen, id, nameArray) {
		if (isOpen) {
			this.currentOpen[nameArray].push(id);
		} else {
			let index = this.currentOpen[nameArray].indexOf(id);
			if (index > -1) {
				this.currentOpen[nameArray].splice(index, 1);
			}
		}
	}

	onPhaseContext($event, project, phase) {
		this.resetSelectedItems();
		this.selected.project = project;
		this.selected.phase = phase;
		this.contextMenu = 'phase';
		this._gS.rigthClick($event, 3);
	}

	onTaskContext($event, project, phase, task) {
		this.resetSelectedItems();
		this.selected.project = project;
		this.selected.phase = phase;
		this.selected.task = task;
		this.contextMenu = 'task';
		this._gS.rigthClick($event, 3);
	}

	onChapterTaskContext(ev) {
		this.resetSelectedItems();
		this.selected.project = ev.project;
		this.selected.phase = ev.phase;
		this.selected.task = ev.task;
		this.selected.chapter = ev.chapter;
		this.contextMenu = 'chapter';
		this._gS.rigthClick(ev.event, 3);
	}

	onTaskTableContext(ev) {
		this.onTaskContext(ev.event, ev.project, ev.phase, ev.task);
		this.contextMenu = 'task-simple';
	}

	onProjectContext($event, project) {
		this.resetSelectedItems();
		this.selected.project = project;
		this.contextMenu = 'project';
		this._gS.rigthClick($event, 3);
	}

	resetSelectedItems() {
		this.selected.project = null;
		this.selected.task = null;
		this.selected.phase = null;
		this.selected.chapter = null;
	}

	sonInfoHover($event) {
		this._gS.rigthClick($event, 3, { 'left': 15, 'top': 0 });
		this._gS.hidemenu();
	}

	changeView(ev) {
		this.view = ev;
	}

	changePositionTask(ev) {
		this.positionTask = ev;
	}

	getPhaseTasks(phase) {
		this.currentScroll = this.timelineWrapper ? this.timelineWrapper.nativeElement.scrollLeft : null;
		this.loading = true;
		this._tS.getProjectTasks(phase.id, this.dateTimeline, this.timelineDuration).subscribe(
			(data: any) => {
				this.mapTasks(data.tasks);
				phase.tasks = data.tasks;
				this.setTasksColor(phase.tasks);
				phase.duration = data.phase_real_duration ? data.phase_real_duration : phase.duration;
				phase.week = data.phase_weeks ? data.phase_weeks : phase.week;
				this.projects = this.projects.slice(); //trigger changes
				this.loading = false;
				this.setScrollTimeLine(this.currentScroll);
			}
		)
	}

	setTasksColor(tasks) {
		tasks.map(task => {
			if (this.module.name == 'post') {
				task.color_code = task.post_color ? task.post_color : '#ffffff';
				task.color_border = '#c4c4c4';
				return;
			}
			task.color_code = '#ffffff';
		})
	}

	mapTasks(tasks) {
		tasks.map(t => {
			t.details = t.details ? t.details : [];
			t.countries_concat_eng = t.task_country.length ? t.task_country.map(c => c.name_eng).join(', ') : '';
			t.countries_concat_esp = t.task_country.length ? t.task_country.map(c => c.name_esp).join(', ') : '';
		})
	}

	getLocalStorageData() {
		let dateItem = this.projectId ? this.getNameDateStorageProject() : 'timeline_start_date';
		let storageDate = localStorage.getItem(dateItem);
		let tableType = localStorage.getItem('timeline_type');
		let timelineDuration = JSON.parse(localStorage.getItem('timeline_duration'));
		let actualDate = new Date();
		let actualDateAux = this._dP.transform(actualDate, 'yyyy-MM-dd');
		this.dateTimeline = storageDate ? storageDate : (this.projectId ? null : actualDateAux);
		this.typeTable = tableType ? (tableType as TYPE_TABLE) : this.TYPE_TABLE.Daily;
		this.timelineDuration = timelineDuration ? (timelineDuration as TIMELINE_DURATION) : this.TIMELINE_DURATION.TwoYears;

		if (!storageDate) {
			localStorage.setItem(dateItem, (this.projectId ? '' : actualDateAux));
		}
	}

	changeTableType(ev: TYPE_TABLE) {
		this.typeTable = ev;
		localStorage.setItem('timeline_type', this.typeTable);
		this.loadData(false);
	}

	changeTableDuration(ev: TIMELINE_DURATION) {
		this.timelineDuration = ev;
		localStorage.setItem('timeline_duration', JSON.stringify(this.timelineDuration));
		this.loadData(false);
	}

	setScrollTimeLine(value) {
		setTimeout(() => {
			if (this.timelineWrapper) {
				this.timelineWrapper.nativeElement.scrollTo({
					left: value,
					behavior: 'auto'
				})
			}
		}, 100)
	}

	paginateTable(type) {
		let currentDate = this._gS.getValidDateTimezone(this.dateTimeline);

		switch (this.typeTable) {
			case TYPE_TABLE.Daily:
				currentDate.setMonth(currentDate.getMonth() + (type == 'previous' ? -1 : 1));
				break;
			case TYPE_TABLE.Weekly:
				currentDate.setMonth(currentDate.getMonth() + (type == 'previous' ? -3 : 3));
				break;
			case TYPE_TABLE.Monthly:
				currentDate.setMonth(currentDate.getMonth() + (type == 'previous' ? -6 : 6));
				break;
		}

		this.dateTimeline = this._dP.transform(currentDate, 'yyyy-MM-dd');
		this.setNewDate();
	}

	setNewDate(saveScroll = true) {
		let dateItem = this.projectId ? this.getNameDateStorageProject() : 'timeline_start_date';
		localStorage.setItem(dateItem, this.dateTimeline);
		this.loadData(saveScroll);
	}

	getProject() {
		this.loading = true;
		if (this._gS.projectSelected && this._gS.projectSelected.id.toString() == this.projectId.toString()) {
			this.currentProject = this._gS.projectSelected;
			this.loadData();
		} else {
			this._pS.getProjectData(this.projectId).subscribe(
				(data: any) => {
					this.currentProject = data.project;
					this.loadData();
				}
			)
		}
	}

	goBack() {
		if (this.currentProject) {
			if (this.module.name == 'post') {
				this.router.navigate(['/projects', this.currentProject.id, 'post']);
			} else {
				this.router.navigate(['/projects', this.currentProject.id]);
			}
		} else {
			this.router.navigate(['/home']);
		}
	}

	drop(event: CdkDragDrop<any[]>, phase) {
		if (event.previousIndex == event.currentIndex) return;
		let task = phase.tasks[event.previousIndex];
		if (!this.canSortTask(event, task, phase)) return;
		let values = {
			task_id: task.id,
			old_position: event.previousIndex + 1,
			new_position: event.currentIndex + 1
		}

		moveItemInArray(phase.tasks, event.previousIndex, event.currentIndex);
		this.projects = this.projects.slice(); //trigger changes

		this._tS.newTaskPosition(values).subscribe(
			data => {
				this.loadData();
			}
		);
	}

	canSortTask(event: CdkDragDrop<any[]>, task, phase): boolean {
		return true;
		// let dependentTasks: any[] = phase.tasks.filter(t => t.predecessor_id == task.id);
		// if (!task.predecessor_id && !dependentTasks.length) return true;
		// let predecessorIndex = phase.tasks.findIndex(t => t.id == task.predecessor_id);
		// // Validates items that has the task as predecessor are placed correctly.
		// if (dependentTasks.length) {
		// 	for (const childTask of dependentTasks) {
		// 		let indexChild = phase.tasks.findIndex(t => t.id == childTask.id);
		// 		if (indexChild <= event.currentIndex) return false;
		// 	}
		// }
		// // Validates moved task is placed after its predecessor.
		// return predecessorIndex == -1 || predecessorIndex < event.currentIndex;
	}

	goToHolidays() {
		if (this.currentProject) {
			if (this.module.name == 'post') {
				this.router.navigate(['/projects', this.currentProject.id, 'post', 'holidays']);
			} else {
				this.router.navigate(['/projects', this.currentProject.id, 'holidays']);
			}
			return;
		}
		this.router.navigate(['/timeline', 'holidays']);
	}

	jumpToStart() {
		let date = this._gS.getValidDateTimezone(this.dateTimeline);
		switch (this.contextMenu) {
			case 'task':
				let start = this.selected.task.real_start;
				if (this.selected.task.details && this.selected.task.details.length) {
					start = this.selected.task.details[0].real_start;
				}
				date.setDate(date.getDate() + start);
				break;
			case 'phase':
				date.setDate(date.getDate() + this.selected.phase.real_start);
				break;
		}
		this.dateTimeline = this._dP.transform(date, 'yyyy-MM-dd');
		this._gS.hidemenu();
		this.resetSelectedItems();
		this.setNewDate(false);
	}

	constructor(
		private router: Router,
		private _pS: ProjetcsService,
		public _tS: TimelineService,
		public _gS: GlobalService,
		private _dP: DatePipe,
		private _cD: ChangeDetectorRef,
		private route: ActivatedRoute,
		private _mS: MenuService) { }

	ngOnInit() {
		this.route.data.subscribe(data => {
			this.module.name = data.module;
		/* 	this.module.access = data.access[0].id;
			console.log(this.module.access) */
			this.route.params.subscribe(
				params => {
					if (params.id) {
						this.projectId = params.id;
						this._mS.manualChangeMenu$.next('projects');
						this.module.access = 55;
						this.getLocalStorageData();
						this.getProject();
					} else {
						this.module.access = 50;
						this.getLocalStorageData();
						this.loadData();
					}
				}
			);
		});
		if (!this.isMainPage){
			this.changeTableDuration(this.TIMELINE_DURATION.HalfYear);
			this.changeTableType(this.TYPE_TABLE.Weekly);
		}
	}

}
